<script setup lang="ts">
import { useLayoutStore } from '@/Stores/layoutStore';

const layoutStore = useLayoutStore();
</script>

<template>
    <div class="bg-gray-900 py-12 sm:py-16">
        <div class="mx-auto max-w-2xl px-6 lg:max-w-7xl lg:px-8">
            <slot name="header">
                <h2 class="text-base/7 font-semibold text-indigo-400">Deploy faster</h2>
                <p class="mt-2 max-w-lg text-4xl font-semibold tracking-tight text-pretty text-white sm:text-5xl">
                    Everything you need to deploy your app
                </p>
            </slot>
            <p class="text-white">
                {{ layoutStore.isFocused ? 'focus' : 'blur' }}
            </p>
            <div class="mt-10 grid gap-4 sm:mt-16" :class="layoutStore.isFocused ? 'grid-cols-1' : 'grid-cols-1 grid-rows-2 lg:grid-cols-6'">
                <slot />
            </div>
        </div>
    </div>
</template>
<style scoped></style>
